module.exports = __webpack_public_path__ + "img/1726034968657-screenshot-1726034933932.png.efacea3e.webp";